import { apiRegistry } from '../../../common/infra/apiRegistry'
import { searchHistoryMem } from '../mem/searchHistoryMem'

apiRegistry.registerPostApi('addSearchHistory', async (req) => {
  const newHistory = {
    id: Date.now().toString(),
    wordId: req.wordId,
    word: req.word,
    briefMeaning: req.briefMeaning,
    searchedAt: new Date().toISOString()
  }

  // Remove duplicate if exists
  const existingIndex = searchHistoryMem.findIndex(h => h.wordId === req.wordId)
  if (existingIndex !== -1) {
    searchHistoryMem.splice(existingIndex, 1)
  }

  searchHistoryMem.push(newHistory)
  return { success: true }
})
